import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import MailPublicExecutionConfirmation from './MailPublicExecutionConfirmation'

const MailPublicExecutionModal = props => {
  return (
    <ControlledModal width="26rem" {...props}>
      <MailPublicExecutionConfirmation />
    </ControlledModal>
  )
}

export default MailPublicExecutionModal
